document.addEventListener("DOMContentLoaded",function(){
  let lastY=window.scrollY;

  window.addEventListener("scroll",function(){
    let y=window.scrollY;

    if(y<=20){
      document.body.classList.remove("nav-compact","nav-hidden");
    }else if(y>lastY && y>120){
      document.body.classList.add("nav-compact","nav-hidden");
    }else if(y<lastY){
      document.body.classList.add("nav-compact");
      document.body.classList.remove("nav-hidden");
    }

    lastY=y;
  });

  function clickElement(el){
    if(!el) return false;
    el.dispatchEvent(new MouseEvent("click",{
      bubbles:true,
      cancelable:true,
      composed:true,
      view:window
    }));
    return true;
  }

  const navItems=document.querySelectorAll(".mobile-bottom-nav a,.mobile-bottom-nav button");

  function setActiveNav(item){
    navItems.forEach(el=>el.classList.remove("is-active"));
    item?.classList.add("is-active");
  }

  if(window.location.pathname === "/"){
    setActiveNav(document.querySelector('.mobile-bottom-nav a[href="/"]'));
  }

  navItems.forEach(item=>{
    const href=item.getAttribute("href");
    if(href && href === window.location.pathname) setActiveNav(item);
  });

  document.querySelector(".bottom-menu-trigger")?.addEventListener("click",function(e){
    e.preventDefault();
    setActiveNav(this);

    const menuButton =
      document.querySelector("header button[aria-label='Menu']") ||
      document.querySelector("header summary[aria-label='Menu']") ||
      document.querySelector("header-drawer summary") ||
      document.querySelector("[aria-controls='menu-drawer']");

    clickElement(menuButton);
  });

  document.querySelector(".bottom-cart-trigger")?.addEventListener("click",function(e){
    e.preventDefault();
    setActiveNav(this);

    const cartDrawer=document.querySelector("cart-drawer-component");

    if(cartDrawer && typeof cartDrawer.open === "function"){
      cartDrawer.open();
      return;
    }

    window.location.href="/cart";
  });

  document.querySelector(".bottom-account-trigger")?.addEventListener("click",function(e){
    e.preventDefault();
    const shopifyAccount=document.querySelector("shopify-account");

    if(shopifyAccount && shopifyAccount.shadowRoot){
      const accountButton=shopifyAccount.shadowRoot.querySelector(".account-button");
      if(clickElement(accountButton)) return;
    }

    window.location.href="/account";
  });

  async function updateBottomCartBadge(){
    try{
      const res=await fetch("/cart.js");
      const cart=await res.json();
      const btn=document.querySelector(".bottom-cart-trigger");
      if(!btn) return;

      let badge=btn.querySelector(".bottom-cart-badge");

      if(cart.item_count > 0){
        if(!badge){
          badge=document.createElement("span");
          badge.className="bottom-cart-badge";
          btn.appendChild(badge);
        }
        badge.textContent=cart.item_count;
      }else if(badge){
        badge.remove();
      }
    }catch(e){}
  }

  updateBottomCartBadge();
  document.addEventListener("cart:updated",updateBottomCartBadge);
  document.addEventListener("cart:update",updateBottomCartBadge);
  document.addEventListener("cart:refresh",updateBottomCartBadge);
});